import { Badge } from '@elkaso-app/web-design';
import { getValidationStatusStyle, validationStatusLabels } from 'pages/invoice-scanning/utils/invoice-scan-status';

export interface IValidationStatusBadge {
  status: string;
}

export const ValidationStatusBadge = ({ status }: IValidationStatusBadge) => {
  const style = getValidationStatusStyle(status);
  const label = validationStatusLabels[status as keyof typeof validationStatusLabels] || status;

  return (
    <Badge px='sm' py='xs' borderRadius='md' fontSize='xs' fontWeight='semibold' color={style.color} bg={style.bgColor}>
      {label}
    </Badge>
  );
};
